/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-state
 * OpenAPI spec version: 1.0.0
 */
import type {
  AbacusStateResponse,
  AbacusStatesResponse,
  CreateAbacusStatesBody,
  CreateAbacusStatesByParentTableHeaders,
  CreateAbacusStatesByParentTableParams,
  CreateAbacusStatesByParentTablePathParameters,
  CreateAbacusStatesHeaders,
  DataloadAbacusStatesHeaders,
  DataloadAbacusStatesResponse,
  GetAbacusStateHeaders,
  GetAbacusStatePathParameters,
  GetAbacusStatesBody,
  GetAbacusStatesByParentTableHeaders,
  GetAbacusStatesByParentTablePathParameters,
  GetHealthHeaders,
  HealthResponse,
  UpdateAbacusStateBody,
  UpdateAbacusStateHeaders,
  UpdateAbacusStatePathParameters,
  UpdateAbacusStatesBody,
  UpdateAbacusStatesHeaders,
  UpdateAbacusStatesPathParameters,
} from "./types";
/**
 * Get an Abacus state by ID
 */
export const getGetAbacusStateUrl = ({
  abacusStateId,
}: GetAbacusStatePathParameters) => {
  return `/abacus-state/${abacusStateId}/`;
};
/**
 * Update an Abacus state
 */
export const getUpdateAbacusStateUrl = ({
  abacusStateId,
}: UpdateAbacusStatePathParameters) => {
  return `/abacus-state/${abacusStateId}/`;
};
/**
 * Get all state actions for a specified parent_table_name and parent_table_id
 */
export const getGetAbacusStatesByParentTableUrl = ({
  parentTableName,
  parentTableId,
}: GetAbacusStatesByParentTablePathParameters) => {
  return `/abacus-state/${parentTableName}/${parentTableId}/`;
};
/**
 * Dataload Abacus states by Abacus state IDs
 */
export const getDataloadAbacusStatesUrl = () => {
  return `/abacus-state/dataloader`;
};
/**
 * Create abacus states
 */
export const getCreateAbacusStatesUrl = () => {
  return `/abacus-states/`;
};
/**
 * Update action status of abacus states
 */
export const getUpdateAbacusStatesUrl = ({
  parentTableName,
}: UpdateAbacusStatesPathParameters) => {
  return `/abacus-states/${parentTableName}/`;
};
/**
 * Create Abacus state records for the specified parent table ID
 */
export const getCreateAbacusStatesByParentTableUrl = (
  {
    parentTableName,
    parentTableId,
  }: CreateAbacusStatesByParentTablePathParameters,
  params?: CreateAbacusStatesByParentTableParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/abacus-states/${parentTableName}/${parentTableId}/?${stringifiedParams}`
    : `/abacus-states/${parentTableName}/${parentTableId}/`;
};
/**
 * Check the health of the application.
 */
export const getGetHealthUrl = () => {
  return `/hello/`;
};
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
import { type Logger, type HeaderProvider } from "@abacus/common";

import { type Throttler } from "@abacus/throttlers";

import { ApiResponse } from "./common";

export interface ApiConfig {
  auth?: HeaderProvider;
  baseUrl?: string;
  logger?: Logger;
  throttler?: Throttler;
}

export class OwsAbacusStateClient {
  auth?: HeaderProvider;
  baseUrl: string;
  logger?: Logger;
  throttler?: Throttler;

  constructor(config?: ApiConfig) {
    this.auth = config?.auth;
    this.baseUrl = config?.baseUrl ?? `https://localhost:8080`;
    this.logger = config?.logger;
    this.throttler = config?.throttler;
  }

  async _fetch<T>(url: string, options: RequestInit): Promise<ApiResponse<T>> {
    // On request
    url = await this._onRequest(url, options);
    // Make request
    const response = await fetch(url, options);
    // Get data
    const data = await this._getData<T>(response);
    const headers = Object.fromEntries(response.headers.entries());
    // Return response
    return { data, headers, status: response.status };
  }

  private _getData<T>(res: Response): Promise<T> {
    const contentType = res.headers.get("content-type");
    if (contentType) {
      if (contentType.includes("application/json")) {
        return res.json() as Promise<T>;
      }
      if (contentType && contentType.includes("application/pdf")) {
        return res.blob() as Promise<T>;
      }
    }
    return res.text() as Promise<T>;
  }

  private async _getHeaders(
    headers?: Record<string, string>,
  ): Promise<Record<string, string>> {
    return {
      ...(await this.auth?.getHeaders()),
      ...headers,
    };
  }

  private async _onRequest(url: string, options: RequestInit): Promise<string> {
    // Throttle the request
    await this.throttler?.wait();
    // Get URL
    url = url = `${this.baseUrl}${url}`;
    // Add Headers
    const headers = options.headers as Record<string, string>;
    options.headers = await this._getHeaders(headers);
    // Log the request
    this.logger?.debug(`Requesting ${options.method} ${url}`);
    return url;
  }

  async getAbacusState(
    { abacusStateId }: GetAbacusStatePathParameters,
    headers?: GetAbacusStateHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusStateResponse>(
        getGetAbacusStateUrl({ abacusStateId }),
        {
          ...options,
          method: "GET",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async updateAbacusState(
    { abacusStateId }: UpdateAbacusStatePathParameters,
    updateAbacusStateBody: UpdateAbacusStateBody,
    headers?: UpdateAbacusStateHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusStateResponse>(
        getUpdateAbacusStateUrl({ abacusStateId }),
        {
          ...options,
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...headers,
            ...options?.headers,
          },
          body: JSON.stringify(updateAbacusStateBody),
        },
      );
    }
  }

  async getAbacusStatesByParentTable(
    {
      parentTableName,
      parentTableId,
    }: GetAbacusStatesByParentTablePathParameters,
    headers?: GetAbacusStatesByParentTableHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        getGetAbacusStatesByParentTableUrl({ parentTableName, parentTableId }),
        {
          ...options,
          method: "GET",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async dataloadAbacusStates(
    getAbacusStatesBody: GetAbacusStatesBody,
    headers?: DataloadAbacusStatesHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<DataloadAbacusStatesResponse>(
        getDataloadAbacusStatesUrl(),
        {
          ...options,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...headers,
            ...options?.headers,
          },
          body: JSON.stringify(getAbacusStatesBody),
        },
      );
    }
  }

  async createAbacusStates(
    createAbacusStatesBody: CreateAbacusStatesBody,
    headers?: CreateAbacusStatesHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(getCreateAbacusStatesUrl(), {
        ...options,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...headers,
          ...options?.headers,
        },
        body: JSON.stringify(createAbacusStatesBody),
      });
    }
  }

  async updateAbacusStates(
    { parentTableName }: UpdateAbacusStatesPathParameters,
    updateAbacusStatesBody: UpdateAbacusStatesBody,
    headers?: UpdateAbacusStatesHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        getUpdateAbacusStatesUrl({ parentTableName }),
        {
          ...options,
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...headers,
            ...options?.headers,
          },
          body: JSON.stringify(updateAbacusStatesBody),
        },
      );
    }
  }

  async createAbacusStatesByParentTable(
    {
      parentTableName,
      parentTableId,
    }: CreateAbacusStatesByParentTablePathParameters,
    params?: CreateAbacusStatesByParentTableParams,
    headers?: CreateAbacusStatesByParentTableHeaders,
    options?: RequestInit,
  ) {
    {
      return this._fetch<AbacusStatesResponse>(
        getCreateAbacusStatesByParentTableUrl(
          { parentTableName, parentTableId },
          params,
        ),
        {
          ...options,
          method: "POST",
          headers: { ...headers, ...options?.headers },
        },
      );
    }
  }

  async getHealth(headers?: GetHealthHeaders, options?: RequestInit) {
    {
      return this._fetch<HealthResponse>(getGetHealthUrl(), {
        ...options,
        method: "GET",
        headers: { ...headers, ...options?.headers },
      });
    }
  }
}
